import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// After the app is mounted
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.ready.then((registration) => {
//     registration.update();
//   });
// }
